import { query_order_used_record_list } from '@/api/mjstore-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model/mjstore/mjstore-orderusedrecord-config';

import { reactive } from 'vue';
import { get_is_delete, getDateTime, toFixed0 } from '@/utils/function';

export default () => {
  const None = null;
  const True = true;
  const False = false;

  const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
  const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店

  const search_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'inline',
    },
    fields: [
      {
        type: 'input',
        name: 'order_code',
        label: '耗单号',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        defaultValue: '',
        placeholder: '请填写耗单号',
      },
      {
        type: 'remotemodal',
        name: 'project_id',
        label: '项目名称',
        disabled: false,
        placeholder: '请选择项目名称',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-project',
      },
      {
        type: 'remotemodal',
        name: 'customer_id',
        label: '会员姓名',
        disabled: false,
        placeholder: '请选择会员姓名',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-customer',
      },
      {
        type: 'remotemodal',
        name: 'staff_id',
        label: '执行人',
        disabled: false,
        placeholder: '请选择执行人',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-staff',
      },
      {
        type: 'remoteselect',
        name: 'bed_id',
        label: '床位',
        disabled: false,
        placeholder: '请选择床位',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-bed',
      },
      {
        type: 'rangepicker',
        name: 'date_interval',
        label: '耗单日期',
        disabled: false,
        allowClear: true,
        inputType: 'number',
        defaultValue: '',
        format: 'YYYY-MM-DD',
        valueFormat: 'YYYY-MM-DD',
        showTime: false,
        placeholder: '请选择耗单日期',
      },
    ],
    rules: {},
    model: reactive({
      org_id: current_org?.id,
      is_active: true,
      order_code: null,
      project_id: null,
      customer_id: null,
      staff_id: null,
      card_id: null,
      shop_id: current_shop?.id,
      bed_id: null,
      date: null,
      is_delete: false,
      delete_staff_id: null,
    }),
  };
  const search_options = {
    is_delete: [
      { value: None, name: '全部' },
      { value: True, name: '已作废' },
      { value: False, name: '未作废' },
    ],
  };

  const edit_model_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'horizontal',
      col: config.creatCol,
    },
    fields: [],
    rules: {},
    model: reactive({
      org_id: current_org?.id,
      is_active: true,
    }),
  };
  const edit_model_config_options = {};

  const update_model_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'horizontal',
      col: config.creatCol,
    },
    fields: [],
    rules: {},
    model: reactive({
      org_id: current_org?.id,
      is_active: true,
    }),
  };
  const update_model_config_options = {};

  const titleList = {
    title: '耗单记录管理',
    addModalTitle: '新建耗单记录',
    updateTitle: '修改耗单记录',
    is_create: false, // 是否有【新建】按钮
    is_update: false, // 是否有【修改】按钮
    is_remove: false, // 是否有【删除】按钮
    is_recover: false, // 是否有【恢复】按钮
  };

  const api_fields: Record = {
    update: {
      id: 'id',
    },
    delete: {
      id: 'id',
    },
    recover: {
      id: 'id',
    },
    updateData: {
      org_id: 'org_id',
      id: 'id',
    },
  };

  const baseColumns: TableColumn[] = [
    {
      title: '序号',
      dataIndex: 'index',
      width: 50,
      fixed: 'left',
    },
    {
      title: '耗单号',
      width: 180,
      dataIndex: 'order_code',
      checked: true,
    },
    {
      title: '订单号',
      width: 180,
      dataIndex: 'order_record__order_code',
      checked: true,
    },
    {
      title: '诉求号',
      width: 170,
      dataIndex: 'require_info__code',
      checked: true,
    },
    {
      title: '会籍门店',
      width: 150,
      dataIndex: 'customer__shop__name',
      checked: true,
    },
    {
      title: '会员编号',
      width: 150,
      dataIndex: 'customer__code',
      checked: true,
    },
    {
      title: '会员姓名',
      width: 150,
      dataIndex: 'customer__name',
      checked: true,
    },
    {
      title: '项目来源',
      width: 180,
      dataIndex: 'origin_project_name',
      slots: { customRender: 'default_none' },
      checked: true,
    },
    {
      title: '项目类别',
      width: 180,
      dataIndex: 'project__project_type__name',
      checked: true,
    },
    {
      title: '项目名称',
      width: 180,
      dataIndex: 'project__name',
      checked: true,
    },
    {
      title: '项目次数',
      width: 75,
      dataIndex: 'num',
      checked: true,
    },
    {
      title: '项目单价',
      width: 75,
      dataIndex: 'project_price',
      checked: true,
      content: (record: any, text: any) => {
        return toFixed0(text);
      },
    },
    {
      title: '项目金额',
      width: 75,
      dataIndex: 'price',
      checked: true,
      content: (record: any, text: any) => {
        return toFixed0(text);
      },
    },
    {
      title: '充值使用金额',
      width: 110,
      dataIndex: 'czje',
      checked: true,
      content: (record: any, text: any) => {
        return toFixed0(text);
      },
    },
    {
      title: '返利使用金额',
      width: 110,
      dataIndex: 'flje',
      checked: true,
      content: (record: any, text: any) => {
        return toFixed0(text);
      },
    },
    {
      title: '直接返利',
      width: 110,
      dataIndex: 'zjfl',
      checked: true,
      content: (record: any, text: any) => {
        return toFixed0(text);
      },
    },
    {
      title: '赠券使用金额',
      width: 110,
      dataIndex: 'zjje',
      checked: true,
      content: (record: any, text: any) => {
        return toFixed0(text);
      },
    },
    {
      title: '换单价差',
      width: 110,
      dataIndex: 'diff_price',
      checked: true,
      content: (record: any, text: any) => {
        return toFixed0(text);
      },
    },
    {
      title: '促销政策',
      width: 110,
      dataIndex: 'cxzc__name',
      checked: true,
    },
    {
      title: '套餐名称',
      width: 150,
      dataIndex: 'set_record__project_set__name',
      checked: true,
    },
    {
      title: '备注',
      width: 200,
      dataIndex: 'mark',
      checked: true,
    },

    {
      title: '所属顾问',
      width: 150,
      dataIndex: 'customer__adviser__name',
      checked: true,
    },
    {
      title: '执行门店',
      width: 80,
      dataIndex: 'shop__name',
      checked: true,
    },
    {
      title: '执行人',
      width: 80,
      dataIndex: 'staff__name',
      checked: true,
    },
    {
      title: '服务人',
      width: 200,
      dataIndex: 'staff_serve_list',
      cellComponent: 'list',
      keyName: 'staff__name',
      checked: true,
      content: (record: any, text: any) => {
        return record.staff_serve_list_str;
      },
    },
    {
      title: '手工费',
      width: 100,
      dataIndex: 'manual_fee',
      checked: true,
    },
    {
      title: '床位编号',
      width: 100,
      dataIndex: 'bed__name',
      checked: true,
    },
    {
      title: '耗单日期',
      width: 150,
      dataIndex: 'date',
      checked: true,
      content: (record: any, text: any) => {
        return getDateTime(text);
      },
    },
    {
      title: '创建日期',
      width: 150,
      dataIndex: 'create_time',
      checked: true,
      content: (record: any, text: any) => {
        return getDateTime(text);
      },
    },
    {
      title: '单据状态',
      width: 110,
      dataIndex: 'is_delete',
      checked: true,
      cellComponent: 'boolean',
      name1: '已作废',
      name2: '未作废',
      color1: 'red',
      color2: 'green',
      filterMultiple: false,
      filters: [
        { text: '全部', value: '' },
        { text: '已作废', value: true },
        { text: '未作废', value: false },
      ],
      content: (record: any, text: any) => {
        return get_is_delete(text);
      },
    },
    {
      title: '确认日期',
      width: 135,
      dataIndex: 'receipt_datetime',
      checked: true,
      content: (record: any, text: any) => {
        return getDateTime(text);
      },
    },
    {
      title: '操作',
      width: 120,
      dataIndex: 'action',
      checked: true,
      cellComponent: 'action',
      fixed: 'right',
    },
  ];
  const newSlotList: any = [];
  Object.assign(newSlotList, slotList);
  newSlotList.push(
    {
      type: 'custom',
      slotName: 'card__project_type__p_type',
      field_0: '面部单',
      field_10: '身体单',
      field_20: '产品单',
      field_1: '次数卡',
      field_11: '时间卡',
      field_21: '产品卡',
      field_2: '套餐',
      field_30: '外科单',
    },
    {
      type: 'custom',
      slotName: 'project__project_type__p_type',
      field_0: '面部单',
      field_10: '身体单',
      field_20: '产品单',
      field_1: '次数卡',
      field_11: '时间卡',
      field_21: '产品卡',
      field_2: '套餐',
      field_30: '外科单',
    },
    { type: 'custom', slotName: 'is_delete', field_true: '已作废', field_false: '未作废' },
    { type: 'list_render', slotName: 'staff_serve_list', field_name: 'staff__name' },
    {
      type: 'custom',
      slotName: 'is_active',
      field_true: '可用',
      field_false: '禁用',
    },
  );

  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_order_used_record_list,
    addData: None,
    updateData: None,
    removeData: None,
    recoverData: None,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
